// extracted by mini-css-extract-plugin
export default {"changelogWrapper":"AssignmentChangelogPopup_changelogWrapper__8SYnU"};